
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Global error handlers for diagnostics
window.addEventListener('error', (event) => {
  console.error('🚨 Global error:', event.error);
  try {
    sessionStorage.setItem('lastGlobalError', JSON.stringify({
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      stack: event.error?.stack,
      timestamp: new Date().toISOString()
    }));
  } catch (e) {
    // Ignore storage errors
  }
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('🚨 Unhandled promise rejection:', event.reason);
  try {
    sessionStorage.setItem('lastUnhandledRejection', JSON.stringify({
      reason: String(event.reason),
      stack: event.reason?.stack,
      timestamp: new Date().toISOString()
    }));
  } catch (e) {
    // Ignore storage errors
  }
});

console.log('🚀 App boot started');

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

console.log('✅ App boot complete - React mounted');
